export default __webpack_public_path__ + "static/media/02.938bc5b9.png";